export class SoundPlayer<Enum> {
  constructor(public readonly soundDirectory: string) {}

  get(path: Enum) {
    if (typeof path === "string") {
      return new Audio(this.soundDirectory + path);
    } else {
      throw new Error("expected a string");
    }
  }
  async play(path: Enum) {
    try {
      await this.get(path).play();
    } catch (err) {
      console.warn(err);
    }
  }
}
